import { Input } from '@coolblue-development/freddy';
import enterApplicationDetailsTrigger from '@coolblue-development/ga4-events/triggers/VacancyApplicationForm/enterApplicationDetailsTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { Rules } from '@sharedTypes';
import { Controller, useFormContext } from 'react-hook-form';
import { isEmail, isMobilePhone } from 'validator';

type Props = {
  name: string;
  type: 'text' | 'email' | 'phonenumber';
  rules?: Rules;
  label: string;
  placeholder: string;
  disable?: boolean;
};

export const TextInputHelper = ({
  name,
  type,
  rules = {},
  label,
  placeholder,
  disable = false
}: Props) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const { trackEvent } = useAnalytics();

  const errorMessage = errors[name]?.message;
  if (errorMessage) {
    trackEvent(
      enterApplicationDetailsTrigger({
        input_field: label,
        status: 'failure',
        content: errorMessage.toString()
      })
    );
  }

  const { validate, ...otherRules } = { ...rules, required: rules.required?.message };
  const emailRule = type === 'email' && {
    validate: (value: string) => (value && isEmail(value)) || validate?.message
  };
  const phoneNumberRule = type === 'phonenumber' && {
    validate: (value: string) => (value && isMobilePhone(value)) || validate?.message
  };
  const validationRules = {
    ...otherRules,
    ...emailRule,
    ...phoneNumberRule
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=''
      rules={validationRules}
      render={value => (
        <Input
          {...value.field}
          label={label}
          type={type === 'email' ? 'email' : 'text'}
          validation={value.fieldState.error ? 'error' : undefined}
          placeholder={placeholder}
          onFocus={() => {
            trackEvent(
              enterApplicationDetailsTrigger({ input_field: label, status: 'focus', content: '' })
            );
          }}
          helperText={value.fieldState.error?.message}
          disabled={disable}
        />
      )}
    />
  );
};
